// SPDX-License-Identifier: AGPL-3.0-or-later

import ChannelPins from '@app/features/channel/state/ChannelPins';
import ForumPosts from '@app/features/forum/state/ForumPosts';
import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import GuildMembers from '@app/features/member/state/GuildMembers';
import MessageReferences from '@app/features/messaging/state/MessageReferences';
import Messages from '@app/features/messaging/state/MessagingMessages';
import SavedMessages from '@app/features/messaging/state/SavedMessages';
import MentionFeed from '@app/features/notification/state/MentionFeed';
import ChannelThreads from '@app/features/threads/state/ChannelThreads';
import CallState from '@app/features/voice/state/CallState';
import VoiceSceneBubbles from '@app/features/voice_scene/state/VoiceSceneBubbles';
import type {GuildMemberData} from '@fluxer/schema/src/domains/guild/GuildMemberSchemas';
import type {Message} from '@fluxer/schema/src/domains/message/MessageResponseSchemas';

interface MessageUpdatePayload {
	id: string;
	channel_id?: string;
}

export function handleMessageUpdate(data: MessageUpdatePayload, _context: GatewayHandlerContext): void {
	const message = data as Message;
	if (message.guild_id && message.member) {
		GuildMembers.hydrateIfMissing(message.guild_id, {
			...message.member,
			user: message.author,
		} as GuildMemberData);
	}
	if (message.mentions && message.guild_id) {
		for (const mention of message.mentions) {
			if (mention.member) {
				GuildMembers.hydrateIfMissing(message.guild_id, {
					...mention.member,
					user: mention,
				} as GuildMemberData);
			}
		}
	}
	if (message.thread !== undefined) {
		ChannelThreads.ingestMessageThreads([message]);
	}
	SavedMessages.handleMessageUpdate(message);
	ForumPosts.handleMessageUpdate(message);
	ChannelPins.handleMessageUpdate(message);
	Messages.handleMessageUpdate({message});
	MessageReferences.handleMessageUpdate(message);
	MentionFeed.handleMessageUpdate(message);
	VoiceSceneBubbles.handleMessageUpdate(message);
	if (message.channel_id && message.call) {
		CallState.handleCallParticipants(message.channel_id, [...message.call.participants]);
	}
}
